import { render, staticRenderFns } from "./preliminary.vue?vue&type=template&id=52dd1a26"
import script from "./preliminary.vue?vue&type=script&lang=js"
export * from "./preliminary.vue?vue&type=script&lang=js"
import style0 from "./preliminary.vue?vue&type=style&index=0&id=52dd1a26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports